module.exports = __webpack_public_path__ + "static/media/background.1dfd7608.png";